import { render } from "./MessageTab.vue?vue&type=template&id=79f3d130&scoped=true&ts=true"
import script from "./MessageTab.vue?vue&type=script&lang=ts"
export * from "./MessageTab.vue?vue&type=script&lang=ts"

import "./MessageTab.vue?vue&type=style&index=0&id=79f3d130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f3d130"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QIcon,QSelect,QChip,QItem,QItemSection,QInput,QInnerLoading,QBtn});qInstall(script, 'directives', {Ripple,ClosePopup});
